<template>
  <div class="v-signup-price__wrapper">
    <slot name="top"></slot>
    <div class="m-md-3 v-signup-price__mobile" :class="!expanded ? 'v-signup-price__mobile--shrink' : ''">
      <v-stack size="xxsmall">
        <div @click="handleExpand()" class="v-signup-price__mobile__btn">{{ expanded ? "Skjul" : "Vis" }}</div>
        <div class="v-signup-price__mobile__content-wrapper" :class="!expanded ? 'v-signup-price__mobile__content-wrapper--shrink' : ''">
          <v-text
            class="text-placeholder v-signup-price__mobile__content-wrapper__title"
            :class="!expanded ? 'v-signup-price__mobile__content-wrapper__title--shrink' : ''"
            font-size="2"
            font-md-size="2"
          >
            {{ title }}
          </v-text>
          <div v-if="price" class="d-flex align-items-end v-signup-price__mobile__content-wrapper__content">
            <v-text
              :font-size="expanded ? '3' : '2'"
              font-md-size="7"
              class="mr-1 v-signup-price__mobile__content-wrapper__content__price"
              :class="!expanded ? 'v-signup-price__mobile__content-wrapper__content__price--shrink' : ''"
            >
              {{ price + ",-" }}
            </v-text>
            <v-text :font-size="expanded ? '2' : '1'" font-md-size="2">{{ !expanded ? priceSuffix : priceSuffix + '*' }}</v-text>
          </div>
        </div>
        <v-text v-if="expanded" font-size="1" class="text-placeholder">{{ !expanded ? description : "*" + description }}</v-text>
      </v-stack>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    price: {
      type: [Number, String],
      default: null
    },
    priceSuffix: {
      type: String,
      default: "kr./md."
    },
    description: {
      type: String,
      required: true
    },
    expanded: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {};
  },
  methods: {
    handleExpand() {
      this.$emit(this.expanded ? "close" : "open");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/component.scss";

.v-signup-price {
  &__mobile {
    &__btn {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .v-signup-price__wrapper {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 11;
    width: 100%;
  }

  .v-signup-price {
    &__mobile {
      background-color: theme-color("dark");
      padding: 16px;
      color: theme-color("light");

      &--shrink {
        height: 50px;
        padding: 6px 16px;
      }

      &__content-wrapper {
        display: flex;
        flex-direction: column;

        &--shrink {
          flex-direction: row;
          gap: 10px;
        }

        &__title {
          margin-bottom: 5px;

          &--shrink {
            margin-bottom: 0px;
          }
        }

        &__content {
          margin: 0;

          &__price {
            font-weight: 700;

            &--shrink {
              font-weight: 400;
            }
          }
        }
      }

      &__btn {
        display: block;
        text-decoration: underline;
        position: absolute;
        font-size: 0.875rem;
        right: 20px;
        color: theme-color("light");
        z-index: 2;
        cursor: pointer;
      }
    }
  }
}
</style>
